import { render, staticRenderFns } from "./endorsementDialog.vue?vue&type=template&id=6dd01a69&scoped=true&"
import script from "./endorsementDialog.vue?vue&type=script&lang=js&"
export * from "./endorsementDialog.vue?vue&type=script&lang=js&"
import style0 from "./endorsementDialog.vue?vue&type=style&index=0&id=6dd01a69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd01a69",
  null
  
)

export default component.exports